import React from 'react';
import { theme } from 'styles/theme';
import { Slide, toast, ToastContainer } from 'react-toastify';
import { ReactComponent as SuccessIcon } from 'assets/icons/svg/toast-success.svg';
import { ReactComponent as CautionIcon } from 'assets/icons/svg/toast-caution.svg';
import { ReactComponent as ErrorIcon } from 'assets/icons/svg/toast-error.svg';
import { ReactComponent as InfoIcon } from 'assets/icons/svg/toast-info.svg';
import 'react-toastify/dist/ReactToastify.css';

type ToastProps = {
  message: string;
  type: 'info' | 'success' | 'error' | 'warn';
};

export const showToast = (props: ToastProps) => {
  switch (props.type) {
    case 'info':
      return toast.info(props.message, {
        progressStyle: {
          backgroundColor: theme.toast.info,
        },
        icon: <InfoIcon />,
      });
    case 'success':
      return toast.success(props.message, {
        progressStyle: {
          backgroundColor: theme.toast.success,
        },
        icon: <SuccessIcon />,
      });
    case 'error':
      return toast.error(props.message, {
        progressStyle: {
          backgroundColor: theme.toast.error,
        },
        icon: <ErrorIcon />,
      });
    case 'warn':
      return toast.warn(props.message, {
        progressStyle: {
          backgroundColor: theme.toast.warn,
        },
        icon: <CautionIcon />,
      });
  }
};

export const Toast: React.FC = () => (
  <ToastContainer
    className='[&_.Toastify__toast-body]:!h-auto [&_.Toastify__toast-icon]:!inline [&_.Toastify--animate-icon]:!inline [&_.Toastify__zoom-enter]:!inline'
    pauseOnFocusLoss={false}
    position='top-center'
    closeButton={false}
    transition={Slide}
    autoClose={4000}
    hideProgressBar
    closeOnClick
    newestOnTop
    rtl={false}
  />
);

export default Toast;
